import { gql } from '@apollo/client';

export const UPDATE_POSITIONS = gql`
  mutation updatePositions($positionUpdateDto: [PositionUpdateDto!]!) {
    updatePositions(positionUpdateDtos: $positionUpdateDto) {
      isDailyPriced
    }
  }
`;
